import React, { useState } from 'react';

import { SearchFields } from './components/SearchFields';
import { ReprocessingAccordion } from './components/ReprocessingAccordion';
import './ReprocessingPage.css';

export function ReprocessingPage() {
  const [search, setSearch] = useState(true);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  return (
    <div style={{ margin: '0px 40px' }}>
      <h1 className="pageTitle logProcessing">Monitoramento de reprocessamento</h1>
      <SearchFields
        setSearch={setSearch}
        setRows={setRows}
        setLoading={setLoading}
        loading={loading}
      />
      <>
        {search ? (
          <>
            <p className="titleResultsProcessing">
              Lista de resultados do monitoramento de reprocessamento
            </p>
            <ReprocessingAccordion data={rows} />
          </>
        ) : (
          <></>
        )}
      </>
    </div>
  );
}
